import React from 'react';
import { useSelector } from 'react-redux';
import BasicRangeShortcuts from '../date-range-picker/BasicRangeShortcuts';
import { FormControl, Select, MenuItem, Button } from '@mui/material';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import CountrySelect from '../country-select/CountrySelect.js';
import FilterState from '../country-select/FilterState.js';
import { useDispatch } from 'react-redux';
import { setCountryFilter, setDateFilter } from '../../containers/app-container/reducer/filterSlice';

const SearchFilter = ({ type, genderFilter,
    setGenderFilter,
    setSearchTerm }) => {

    const selectedCountry = useSelector(state => state.filter.country)
    const defaultDateRange = useSelector(state => state.filter.defaultDateRange)
    const dispatch = useDispatch();

    return (
        <>
            <div className="d-flex gap-2 justify-content-between align-items-center py-16">
                <div className="d-flex gap-2 justify-content-between align-items-center">
                    <div className="bg-light-100 d-flex align-items-center gap-3 radius-8" style={{ border: '1px solid #d1d5db', }}>
                        <CountrySelect />
                        {selectedCountry ?
                            <FilterState /> : null}
                    </div>
                    {type !== 'chat' ? <>
                        <BasicRangeShortcuts id="range1" />

                        {/* //status filter */}
                        <FormControl
                            size="small"
                            sx={{
                                minWidth: 120,
                                boxShadow: 'none',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '6px',
                                    background: '#f3f4f6',
                                    boxShadow: 'none',
                                    '& fieldset': {
                                        borderColor: '#d1d5db', // Default border color
                                        borderWidth: '1px',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#9ca3af', // Hover border color (gray-400)
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#2563eb', // Focused border (blue-600)
                                        borderWidth: '1.5px',
                                    },
                                },
                            }}
                        >
                            <Select
                                value={genderFilter}
                                onChange={(e) => setGenderFilter(e.target.value)}
                                IconComponent={KeyboardArrowDownOutlinedIcon} // custom arrow icon
                                displayEmpty
                                sx={{
                                    fontSize: '14px',
                                    height: '40px',
                                    '& .MuiSelect-select': {
                                        padding: '8px 12px',
                                        fontSize: '14px',
                                        fontFamily: "Neue Montreal",
                                    },
                                    fontFamily: "Neue Montreal",
                                }}
                            >
                                <MenuItem value="" sx={{ fontSize: '14px', fontFamily: "Neue Montreal", }}>
                                   All Gender
                                </MenuItem>
                                <MenuItem value="male" sx={{ fontSize: '14px', fontFamily: "Neue Montreal", }}>
                                    Male
                                </MenuItem>
                                <MenuItem value="female" sx={{ fontSize: '14px', fontFamily: "Neue Montreal", }}>
                                    Female
                                </MenuItem>
                            </Select>
                        </FormControl>



                        <Button
                            className=""
                            sx={{
                                textTransform: 'capitalize',
                                fontSize: '14px',
                                fontWeight: '400',
                                color: '#000000de',
                                height: '40px',
                                borderRadius: '8px',
                                border: '1px solid #d1d5db', // light gray border
                                backgroundColor: '#fff',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: '#BE1F1F', // blue hover
                                    color: '#fff', // white text on hover
                                    borderColor: '#ff4A4A', // blue border
                                },
                                fontFamily: "Neue Montreal",
                            }}
                            onClick={() => {
                                setSearchTerm("");
                                setGenderFilter("");
                                dispatch(setCountryFilter({ country: null }));
                                dispatch(setDateFilter({ dateRange: defaultDateRange }));
                            }}
                        >
                            Reset
                        </Button></> : null}
                </div>
            </div>
        </>
    );
};

export default SearchFilter; 
